import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Lesson} from '@model/lesson';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppConfigurationService} from '../shared/app-configuration.service';
import {LessonsGroup} from '@model/lesson-group';

@Injectable({
  providedIn: 'root'
})
export class LessonService {

  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = `${this._appConfig.getConfig().apiUrl}/schools`;
  }

  loadLessons(schoolId: string, attributionYear: number): Observable<Lesson[]> {
    const parameters = new HttpParams()
      .set('year', attributionYear + '');
    return this._http.get<Lesson[]>(`${this._apiUrl}/${schoolId}/lessons`, {params : parameters});
  }

  saveLesson(lesson: Lesson, schoolId: string): Observable<Lesson> {
    if (lesson.id) {
      return this._http.put<Lesson>(`${this._apiUrl}/${schoolId}/lessons/${lesson.id}`, lesson);
    } else {
      return this._http.post<Lesson>(`${this._apiUrl}/${schoolId}/lessons`, lesson);
    }
  }

  deleteLesson(id: number, schoolId: string) {
    return this._http.delete<void>(`${this._apiUrl}/${schoolId}/lessons/${id}`);
  }

  loadLessonsGroups(schoolId: string, attributionYear: number): Observable<LessonsGroup[]> {
    const parameters = new HttpParams()
      .set('year', `${attributionYear}`);
    return this._http.get<LessonsGroup[]>(`${this._apiUrl}/${schoolId}/lessonsGroups`, {params : parameters});
  }

  createLessonsGroup(schoolId: string, lessonGroup: LessonsGroup): Observable<number> {
    return this._http.post<number>(`${this._apiUrl}/${schoolId}/lessonsGroups`, lessonGroup);
  }

  saveLessonsGroup(schoolId: string, lessonsGroupId:number, lessonGroup: LessonsGroup): Observable<void> {
    return this._http.put<void>(`${this._apiUrl}/${schoolId}/lessonsGroups/${lessonsGroupId}`, lessonGroup);
  }

  deleteLessonsGroup(schoolId: string, lessonsGroupId: number): Observable<void> {
    return this._http.delete<void>(`${this._apiUrl}/${schoolId}/lessonsGroups/${lessonsGroupId}`);
  }

  addLessonInLessonsGroup(schoolId: string, lessonsGroupId: number, lessonId: number): Observable<void> {
    return this._http.put<void>(`${this._apiUrl}/${schoolId}/lessonsGroups/${lessonsGroupId}/lesson/${lessonId}`, {});
  }

  removeLessonInLessonsGroup(schoolId: string, lessonsGroupId: number, lessonId: number): Observable<void> {
    return this._http.delete<void>(`${this._apiUrl}/${schoolId}/lessonsGroups/${lessonsGroupId}/lesson/${lessonId}`);
  }
}
